const COLORS = require("../data/colors.js");
const THREE = require("three");
const vLN323 = 32;
const v6305 = vLN323 / 2;
class SkyDome extends THREE.Mesh {
  static fromConfig(p7543, p7544) {
    return new SkyDome(p7544, p7543.skyDomeCol0, p7543.skyDomeCol1, p7543.skyDomeCol2, p7543.skyDomeEmis, p7543.skyDomeEmisTex, p7543.skyDomeTex, p7543.skyDomeMovD, p7543.skyDomeMovT, p7543.skyDomeTexA);
  }
  constructor(p7545, p7546, p7547, p7548, p7549, p7550, p7551, p7552, p7553, p7554) {
    let v6306 = p7551 ? p7550 ? "#ffffff" : p7549 || undefined : undefined;
    p7550 = parseInt(p7550 || 0);
    if (v6306 == "#000000" && !p7550) {
      v6306 = undefined;
    }
    var vO182 = {
      src: p7551 ? p7554 ? parseInt(p7554 || 0) + "/texture" : "sky_6" : undefined,
      emissive: v6306,
      movT: p7553 != null && p7553 / 1000000,
      movD: p7552,
      asset: !!p7554 || undefined,
      vertexColors: false
    };
    let v6307 = new THREE[v6306 ? "StrippedLambertMaterial" : "MeshBasicMaterial"]({
      color: "#ffffff",
      depthWrite: false,
      flatShading: false,
      vertexColors: false,
      side: THREE.BackSide,
      transparent: true,
      emissive: v6306
    });
    v6307.onBeforeCompile = p7555 => {
      if (p7555.defines) {
        p7555.defines.USE_UV = "";
      } else {
        p7555.defines = {
          USE_UV: ""
        };
      }
      p7555.uniforms.firstColor = {
        value: new THREE.Color(p7546 || COLORS.skyDome[0])
      };
      p7555.uniforms.middleColor = {
        value: new THREE.Color(p7547 || COLORS.skyDome[1])
      };
      p7555.uniforms.endColor = {
        value: new THREE.Color(p7548 || COLORS.skyDome[2])
      };
      p7555.fragmentShader = "\n\t\t\t\tvarying vec2 vUv_kr;\n\t\t\t\tuniform vec3 firstColor;\n\t\t\t\tuniform vec3 middleColor;\n\t\t\t\tuniform vec3 endColor;\n\t\t\t\tvec2 RES = vec2(512,512);\n\t\t\t\tvec3 getGradient(vec2 coord) {\n\t\t\t\t\tvec2 xy = coord.yx / RES;\n\t\t\t\t\tfloat h = 0.5; // adjust position of middleColor\n\t\t\t\t\tvec3 col = mix(mix(endColor, middleColor, xy.x/h), mix(middleColor, firstColor, (xy.x - h)/(1.0 - h)), step(h, xy.x));\n\n\t\t\t\t\treturn col;\n\t\t\t\t}\n\t\t\t" + p7555.fragmentShader.replace("#include <dithering_fragment>", "\n\t\t\t\t#include <dithering_fragment>\n\t\t\t\tgl_FragColor.rgb *= getGradient(RES*vUv_kr);\n\t\t\t");
      p7555.vertexShader = "\n\t\t\t\tvarying vec2 vUv_kr;\n\t\t\t" + p7555.vertexShader.replace("#include <fog_vertex>", "\n\t\t\t\t#include <fog_vertex>\n\t\t\t\tvUv_kr=uv;\n\t\t\t");
    };
    if (vO182.src) {
      p7545.loadTexture(v6307, vO182.src, vO182);
      if (v6306 && p7550) {
        p7545.loadTexture(v6307, p7550 + "/texture", vO182, "emissiveMap");
      } else if (v6306) {
        p7545.loadTexture(v6307, vO182.src + "_e", vO182, "emissiveMap");
      }
    }
    let v6308 = new THREE.SphereGeometry(50, vLN323, v6305);
    v6308.computeBoundingBox();
    v6308.computeBoundingSphere();
    v6308.computeVertexNormals(true);
    super(v6308, v6307);
    this.doubleSided = false;
  }
}
module.exports = SkyDome;